module.exports = __webpack_public_path__ + "assets/media/morning.48a2449c.mp3";